var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from '../../common-theme/api/agency.service';
import { LocaleAwareBaseComponent } from '../../common-theme/seo/locale-aware-base.component';
var FooterComponent = /** @class */ (function (_super) {
    __extends(FooterComponent, _super);
    function FooterComponent(agencyService) {
        var _this = _super.call(this) || this;
        _this.agencyService = agencyService;
        _this.date = new Date();
        return _this;
    }
    return FooterComponent;
}(LocaleAwareBaseComponent));
export { FooterComponent };



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts.pre-build-optimizer.js